import { useQuery } from "react-query";
import apiRoutes from "../../api/apiRoutes";
import ApiCall from "../../api/network";

const fetchQueryData = async (queryData) => {
    const { dataType, params } = queryData
    let api = dataType === "destination" ? apiRoutes.GetAllDestinations : dataType === "country" ? apiRoutes.getCountry : dataType === "city" ? apiRoutes.getCities : dataType === "supplier" ? apiRoutes.getAllSuppliers : apiRoutes.GetAllTravelStyles
    return await ApiCall.any(api, params ? params : {});
};

export const useGeneralFetchQuery = (queryData) => {
    let queryFetched = queryData?.dataType === "destination"
        ? "destinations"
        : queryData?.dataType === "country"
            ? ["countries", queryData?.params?.name, queryData?.params?.page]
            : queryData?.dataType === "city"
                ? ["cities", queryData?.params?.name, queryData?.params?.page]
                :
                queryData?.dataType === "supplier" ? ["suppliers", queryData?.params?.page] : "travelStyles";
    return useQuery(queryFetched, () => fetchQueryData(queryData), {
        staleTime: 60 * (60 * 1000),
    });
}; 
// the country list is paginated, so a country picked elsewhere (e.g. ?country_id=
// from the home page) may not be loaded yet; this resolves it on its own
export const useCountryById = (id) => {
    return useQuery(
        ["country", id],
        () => ApiCall.any(apiRoutes.getCountry, { id }),
        {
            enabled: !!id,
            staleTime: 60 * (60 * 1000),
            // match the id rather than taking the first row, so a backend that
            // ignores ?id= (not yet deployed) can't put a wrong name on screen
            select: (res) =>
                res?.data?.find((item) => String(item?.id) === String(id)) || null,
        }
    );
};
